<template>
    <div class="big-stavka-wrapper">
        <div class="troskovnik-element-title">{{ $t("forms.cost_sheet.satnica.title") }}</div>
        <div class="troskovnik-stavke-wrapper">
            <div class="fiksne-stavke-header">
                <div class="st sst1">{{ $t("forms.cost_sheet.satnica.h1") }}</div>
                <div class="st bd4">{{ $t("forms.cost_sheet.satnica.h2") }}</div>
                <div class="st bd4">{{ $t("forms.cost_sheet.satnica.h3") }}</div>
                <div class="st bd6">{{ $t("forms.cost_sheet.satnica.h4") }}</div>
            </div>
            <div class="stavke-wrapper breakdown-wrapper">
                <div class="stavke-row" v-for="(stavka,key) in stavke" :key="key">
                    <div class="row-number">{{stavka.id}}</div>
                    <div class="fiksna-stavka">
                        <textarea class="breakdown-el breakdown-textarea sst1" height="43px" v-model="stavka.opis"/>
                        <textarea style="resize:none;" class="breakdown-el breakdown-textarea bd4 bolded" disabled 
                            :value="breakdowns_list.filter(b=>b.belonging_satnica_id == stavka.id).map((b)=>b.local_id).join(', ')" />
                        <div class="breakdown-time-wrapper bd5 breakdown-el stavka-iznos bolded">
                            <div class="time-wrapper">
                                <input disabled type="number" :value="stavka.time_h">
                                <span> h</span>
                            </div>
                            <div class="time-wrapper">
                                <input disabled type="number" v-model="stavka.time_min">
                                <span> min</span>
                            </div>
                        </div>
                        <input type="text" class="breakdown-el stavka-iznos bd6 bolded" disabled v-model="stavka.iznos" @input="calculateVAT(stavka)">
                    </div>
                    <div v-if="(stavke.length>1)" class="add-napomena add-button remove-item" @click="stavke.length>1 ? deleteStavka(stavka):''">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="add-new" @click="add_new">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="12" height="12" version="1.1" viewBox="0 0 12 12"><defs/><desc>Generated with Avocode.</desc><g><g><title>Shape 544</title><path d="M10.88006,4.71948c-0.14734,-0.14586 -0.32628,-0.2183 -0.5368,-0.2183h-3.28338v0v-3.24824c0,-0.20795 -0.07367,-0.38519 -0.22101,-0.53089c-0.14722,-0.1457 -0.32604,-0.21863 -0.5368,-0.21863h-1.51527c-0.21052,0 -0.38934,0.07293 -0.53668,0.21863c-0.14734,0.1457 -0.22101,0.32294 -0.22101,0.53089v3.24824v0h-3.28338c-0.2104,0 -0.38934,0.07243 -0.53668,0.2183c-0.14746,0.14603 -0.22101,0.3226 -0.22101,0.53072v1.4992c0,0.20828 0.07355,0.38536 0.22101,0.53105c0.14734,0.1457 0.32628,0.21846 0.53668,0.21846h3.28326v0v3.2479c0,0.20812 0.07379,0.38536 0.22113,0.53105c0.14734,0.1457 0.32616,0.2183 0.53668,0.2183h1.51539c0.21064,0 0.38934,-0.0726 0.53668,-0.2183c0.14746,-0.1457 0.22113,-0.32294 0.22113,-0.53105v-3.2479v0h3.28326c0.21064,0 0.38958,-0.07277 0.5368,-0.21846c0.14734,-0.1457 0.22101,-0.32277 0.22101,-0.53105v-1.4992c0,-0.20812 -0.07367,-0.38502 -0.22101,-0.53072z" fill="#7b7b8a" fill-opacity="1"/></g></g></svg>
                <span>{{ $t("forms.cost_sheet.satnica.add") }}</span>
            </div>
            <!-- <div class="big-total-wrapper"> -->
                <!-- <div class="subtotal-wrapper">
                    <div :class="['subtotal-value',isTimeUnused ? 'unused' : 'used']"><span>preostalo sati</span><span>{{getRemainingTime}}</span></div>
                    <div :class="['subtotal-value',isMoneyUnused ? 'unused' : 'used']"><span>preostalo za zaračunati (EUR)</span><span>{{getRemainingMoney.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div>
                </div> -->
                <div class="subtotal-wrapper">
                    <div class="subtotal-value"><span>{{ $t("forms.cost_sheet.satnica.total_h") }}</span><span>{{getUkSatiMin}}</span></div>
                    <div class="subtotal-value"><span>{{ $t("forms.cost_sheet.satnica.total_val") }}</span><span>{{getValue.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div>
                    <div class="subtotal-value"><span>{{ $t("forms.cost_sheet.satnica.vat",{value:vat_percentage}) }}</span><span>{{(getVAT).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div>
                    <div class="subtotal-value"><span>{{ $t("forms.cost_sheet.satnica.total") }}</span><span>{{(getSUM).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div>
                </div>
            <!-- </div> -->
        </div>
        <v-dialog v-model="cant_delete" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ $t("forms.cost_sheet.satnica.err") }}
                </div>
                <div class="vdialog-buttons-wrapper">
                <div class="universal-vdialog-button vbutton-secondary" @click="cant_delete = false;"> {{$t("repetitive.okay")}} </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    props:['stavke', 'init_time', 'init_iznos', 'breakdowns_list', "vat_percentage"],
    methods: {
        add_new(){
            this.stavke.push({id: Math.max(...this.stavke.map(s=>s.id))+1, opis:'', time_h:0, time_min:0, iznos:0, vat_iznos:0});
            this.$emit("refreshListeners");
        },
        deleteStavka(delete_this){
            if (this.breakdowns_list.find((el)=>el.belonging_satnica_id == delete_this.id)) {
                //javi da nebre obrisati jer ima u breakdownu povezanih
                this.cant_delete = true;
            }
            else{
                let updated_stavke = this.stavke.filter(st=>st != delete_this);
                this.$emit('update:stavke', updated_stavke);
                this.$emit("refreshListeners");
            }
        },
        calculateVAT(stavka){
            stavka.vat_iznos = stavka.iznos*(this.vat_percentage/100);
        },
        calculateValue(){
            this.stavke.forEach((st)=>{
                const belonging_breakdowns = this.breakdowns_list.filter((b)=>b.belonging_satnica_id == st.id);
                st.iznos = belonging_breakdowns.reduce(function(prev,next){return prev+Number(next.iznos)},0).toFixed(2);
                st.vat_iznos = (belonging_breakdowns.reduce(function(prev,next){return prev+Number(next.iznos)},0)*(this.vat_percentage/100)).toFixed(2);
                let uk_sati = belonging_breakdowns.reduce(function(prev,next){return prev+Number(next.time_h)},0);
                let uk_min = belonging_breakdowns.reduce(function(prev,next){return prev+Number(next.time_min)},0);
                if (uk_min>=60) {
                    const new_sati = parseInt(uk_min/60);
                    uk_sati+=new_sati;
                    uk_min=uk_min-(new_sati*60);
                }
                st.time_h = uk_sati;
                st.time_min = uk_min;
            })
        }
        // getDate(date){
        //     return moment(date).format("DD.MM.YYYY.");
        // },
    },
    model:{
        prop: 'stavke',
        event: 'click'
    },
    watch:{
        breakdowns_list: {
            handler(){
                this.calculateValue();
            },
            deep:true
        },
        vat_percentage: function() {
            this.calculateValue();
        }
    },
    data() {
        return {
            unused_time:0,
            unused_money:0,
            cant_delete:false,
        }
    },
    computed:{
        getValue(){
            return this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.iznos)},0) : 0;
        },
        getVAT(){
            return this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.vat_iznos)},0) : 0;
        },
        getSUM(){
            return this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.iznos)+Number(next.vat_iznos)},0) : 0;
        },
        getUkSatiMin(){
            let uk_sati = this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.time_h)},0) : 0;
            let uk_min = this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.time_min)},0) : 0;
            if (uk_min>=60) {
                const new_sati = parseInt(uk_min/60);
                uk_sati+=new_sati;
                uk_min=uk_min-(new_sati*60);
            }
            return `${uk_sati}h ${uk_min}min`;
        },
        getRemainingTime(){
            let uk_sati=0;
            let uk_mins=0;
            const rest_time = this.init_time-(this.stavke.length>0 ? this.stavke.reduce(function(prev,next){return prev+Number(parseInt(next.time_h)*60+parseInt(next.time_min))},0) : 0);
            if (rest_time>=60) {
                const new_sati = parseInt(rest_time/60);
                uk_sati=new_sati;
                uk_mins=rest_time-(new_sati*60);
            }
            else{
                uk_mins=rest_time;
            }
            this.unused_time=rest_time;
            return `${uk_sati}h ${uk_mins}min`;
        },
        getRemainingMoney(){
            const total_inserted = this.getValue;
            this.unused_money = this.init_iznos.toFixed(2) - total_inserted.toFixed(2);
            return this.unused_money;
        },
        isTimeUnused(){
            return this.unused_time!=0;
        },
        isMoneyUnused(){
            return this.unused_money!=0;
        }
    }
}
</script>